import { applyMiddleware, combineReducers, createStore } from 'redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';
import { restoreFromPersist } from '@shared/scenes/chat/thread/store/actions';
import { setStore } from '@shared/store';
import { reducers } from '@shared/store/reducers';

const showReduxLogger = false;

export function configureStore(): MBStore {
  const reducer = combineReducers(reducers);
  const middleware = applyMiddleware(thunk);
  const middlewareWithLogger = applyMiddleware(thunk, logger);
  const store = createStore(reducer, showReduxLogger ? middlewareWithLogger : middleware);
  setStore(store);
  restoreFromPersist();
  return store;
}
